// extracted by mini-css-extract-plugin
module.exports = {"main":"science-process-module--main--1TjDi","icon":"science-process-module--icon--3vB1a","text":"science-process-module--text--3jYtS"};